import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs) {
    return twMerge(clsx(inputs));
}

export function formatDate(dateString) {
    if (!dateString) return '';
    const date = new Date(dateString);
    return date.toLocaleDateString('it-IT', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric'
    });
}

export function formatDateTime(dateString) {
    if (!dateString) return '';
    const date = new Date(dateString);
    return date.toLocaleString('it-IT', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit'
    });
}

export function formatMinutesToHours(minutes) {
    if (!minutes && minutes !== 0) return '-';
    const hours = Math.floor(minutes / 60);
    const mins = minutes % 60;
    return `${hours}h ${mins}min`;
}

export function getStatusColor(status) {
    switch (status) {
        case 'open':
            return 'text-[#00FF41] border-[#00FF41]';
        case 'in_progress':
            return 'text-yellow-400 border-yellow-400';
        case 'closed':
            return 'text-gray-400 border-gray-400';
        default:
            return 'text-white border-white';
    }
}

export function getStatusLabel(status) {
    switch (status) {
        case 'open':
            return 'APERTO';
        case 'in_progress':
            return 'IN CORSO';
        case 'closed':
            return 'CHIUSO';
        default:
            return status?.toUpperCase() || '-';
    }
}
